import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, Modal, Form, Popconfirm, DatePicker, Row, Col, notification, message, Upload } from 'antd'
import { SearchOutlined, RedoOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined"
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { CheckImgs } from "../../component/common/Imgs"
import getPermission from '../../js/permission'
import { ngetBase64 } from '../../js/globalParam'
import { apiPrefix } from '../../js/config'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type fetchParams = {
    menu_item_name: string | undefined
    menu_style_id: string | undefined
    menu_type_id: string | undefined
    is_sugar: number | undefined
    is_high_price: number | undefined
    date: any
}

const initForm = {
    menu_item_name: undefined,
    menu_style_id: undefined,
    menu_type_id: undefined,
    menu_item_url: undefined,
    menu_item_desc: undefined,
    is_sugar: 0,
    is_high_price: 0,
    food_item_list: [
        {
            food_type_id: undefined,
            food_item_id: undefined,
            use_count: undefined,
            remark: undefined
        }
    ]
}

interface formRow {
    food_type_id: string | undefined
    food_item_id: string | undefined
    use_count: string | undefined
    use_unit?: string | undefined
    remark: string | undefined
}

function beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG格式的图片文件!')
    }

    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        message.error('上传图片不能大于2MB!')
    }

    return isJpgOrPng && isLt2M
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        menu_item_name: undefined,
        menu_style_id: undefined,
        menu_type_id: undefined,
        is_sugar: undefined,
        is_high_price: undefined,
        date: null
    }

    let formRow: formRow = {
        food_type_id: undefined,
        food_item_id: undefined,
        use_count: undefined,
        remark: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [data, setData] = useState<any>([])

    const [selects, setSelects] = useState<any[]>([])
    const [unit, setUnit] = useState<string[]>([])

    const [previewImage, setPreviewImage] = useState<string>('')
    const [urls, setUrls] = useState<string[]>([])

    const [visible, setVisible] = useState<boolean>(false)
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [formData, setFormData] = useState<formRow[]>([])
    const [form] = Form.useForm()

    const [activeID, setActiveID] = useState<string | undefined>(undefined)
    const [addVisible, setAddVisible] = useState<boolean>(false)

    const [menuStyleList, setMenuStyleList] = useState<{ menu_style_id: string, menu_style_name: string }[]>([])
    const [menuTypeList, setMenuTypeList] = useState<{ menu_type_id: string, menu_type_name: string }[]>([])
    const [foodTypeList, setFoodTypeList] = useState<{ food_type_id: string, food_type_name: string }[]>([])

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        // 查询菜系
        baseAxiosNoInfo('/cooking_center/global/menu_style_list').then((res: any) => {
            res && setMenuStyleList(res)
        })

        // 查询菜品分类
        baseAxiosNoInfo('/cooking_center/global/menu_type_list').then((res: any) => {
            res && setMenuTypeList(res)
        })

        // 查询食材分类
        baseAxiosNoInfo('/cooking_center/global/food_type_list').then((res: any) => {
            res && setFoodTypeList(res)
        })
    }, [])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.update_time_start_day = params.date[0].format('YYYY-MM-DD')
            params.update_time_end_day = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/cooking_center/menu_item/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const onFinish = (values: any) => {
        let url = activeID ? '/cooking_center/menu_item/update' : '/cooking_center/menu_item/add'
        values.menu_item_url = values.menu_item_url[0].response.data[0]

        if (activeID) {
            values.id = activeID
        }

        baseAxiosComplete.post(url, {
            menu_item_id: activeID,
            food_item_list: formData,
            ...values
        }).then(res => {
            if (res.status === 0) {
                form.setFieldsValue(initForm)

                setAddVisible(false)
                resetForm()
            }
        })
    }

    /**
     * 菜品图片上传
     */
    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setPreviewImage(file.preview)
        setVisible(true)
    }

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const addMoreRow = () => {
        let s = _.cloneDeep(selects)
        s.push([])

        setSelects(s)
        setFormData([...formData, formRow])
    }

    const deleteRow = (index: number) => {
        if (formData.length > 1) {
            let reciveD = _.cloneDeep(formData)
            reciveD.splice(index, 1)

            setFormData(reciveD)
        }
    }

    const handleRowChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(formData)
        reciveD[index][attr] = value

        setFormData(reciveD)
    }

    return (<div className="common-page">
        {/* 膳食中心 -> 菜品管理 -> 菜品管理 */}
        <BreadCrumb position={['膳食中心', '菜品管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="菜品名称" value={fetchOtherParams.menu_item_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'menu_item_name') }} />

                <Select showSearch allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="菜品分类" value={fetchOtherParams.menu_type_id}
                    filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
                    onChange={(value: string) => { handleChange(value, 'menu_type_id') }}
                >
                    {
                        menuTypeList.map((el: { menu_type_id: string, menu_type_name: string }) =>
                            <Option key={el.menu_type_id} value={el.menu_type_id}>{el.menu_type_name}</Option>)
                    }
                </Select>

                <Select showSearch allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="菜系" value={fetchOtherParams.menu_style_id}
                    filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
                    onChange={(value: string) => { handleChange(value, 'menu_style_id') }}
                >
                    {
                        menuStyleList.map((el: { menu_style_id: string, menu_style_name: string }) =>
                            <Option key={el.menu_style_id} value={el.menu_style_id}>{el.menu_style_name}</Option>)
                    }
                </Select>

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="是否含糖" value={fetchOtherParams.is_sugar}
                    onChange={(value: number) => { handleChange(value, 'is_sugar') }}
                >
                    <Option value={1}>是</Option>
                    <Option value={0}>否</Option>
                </Select>
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 140 }}
                    placeholder="是否高价菜品" value={fetchOtherParams.is_high_price}
                    onChange={(value: number) => { handleChange(value, 'is_high_price') }}

                >
                    <Option value={1}>是</Option>
                    <Option value={0}>否</Option>
                </Select>

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["更新开始日期", "更新结束日期"]} value={fetchOtherParams.date}
                    onChange={(v: any) => { handleChange(v, 'date') }}
                />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes("添加") && <Button type="primary" style={{ marginRight: 12, marginBottom: 12 }} onClick={() => {
                    form.setFieldsValue(initForm)

                    setActiveID(undefined)
                    setAddVisible(true)

                    setSelects([])
                    setUnit([])
                    setFormData([])
                }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="menu_item_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="菜品名称" dataIndex="menu_item_name" key="menu_item_name" />
                <Column title="菜系" dataIndex="menu_style_name" key="menu_style_name" />
                <Column title="菜品分类" dataIndex="menu_type_name" key="menu_type_name" />

                <Column title="菜品图片" dataIndex="menu_item_url" key="menu_item_url"
                    render={(v: any) => {
                        return <Button onClick={
                            () => {
                                setUrls(v.split(','))
                                setSiperVisible(true)
                            }} size="small">查看</Button>
                    }}
                />
                <Column title="菜品功效" dataIndex="menu_item_desc" key="menu_item_desc" width={600} render={
                    info => {
                        let br = <br></br>;
                        let result = null;
                        let content_list = info.split('\n')
                        for (let j = 0; j < content_list.length; j++) {
                            if (j === 0) {
                                result = content_list[j];
                            } else {
                                result = <span>{result}{br}{content_list[j]}</span>;
                            }
                        }
                        return <div>{result}</div>;
                    }} />

                <Column title="是否含糖" dataIndex="is_sugar_desc" key="is_sugar_desc" />
                <Column title="是否高价菜品" dataIndex="is_high_price_desc" key="is_high_price_desc" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {permission.includes('编辑') && <Button type="primary" size="small" onClick={() => {
                                setFormData([])

                                baseAxiosNoInfo('/cooking_center/menu_item/detail', { params: { menu_item_id: record.menu_item_id } }).then((res: any) => {
                                    if (res) {
                                        form.setFieldsValue({
                                            menu_item_name: res.menu_item_name,
                                            menu_style_id: res.menu_style_id,
                                            menu_type_id: res.menu_type_id,
                                            menu_item_url: [{ id: '', response: { data: [res.menu_item_url] }, url: res.menu_item_url }],
                                            menu_item_desc: res.menu_item_desc,
                                            is_sugar: res.is_sugar,
                                            is_high_price: res.is_high_price,
                                        })

                                        setActiveID(record.menu_item_id)
                                        setAddVisible(true)

                                        let u = _.cloneDeep(unit)
                                        let f: any = []

                                        res.food_item_list.forEach((el: any, index: number) => {
                                            f.push({
                                                food_item_id: el.food_item_id,
                                                remark: el.remark,
                                                use_count: el.use_count,
                                                food_type_id: el.food_type_id
                                            })

                                            u.push(el.use_unit)

                                            baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                                params: {
                                                    food_type_id: el.food_type_id
                                                }
                                            }).then((res: any) => {
                                                if (res) {
                                                    let s = _.cloneDeep(selects)
                                                    s[index] = res
                                                    setSelects(s)
                                                }
                                            })
                                        })

                                        setFormData(f)
                                        setUnit(u)
                                    }
                                })

                            }}>编辑</Button>}

                            {permission.includes('删除') && <Popconfirm
                                title="确定删除?"
                                onConfirm={() => {
                                    baseAxiosComplete.post('/cooking_center/menu_item/delete', {
                                        id: record.menu_item_id
                                    }).then(res => {
                                        if (res.status === 0) {
                                            resetForm()
                                        }
                                    })
                                }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button size="small">删除</Button>
                            </Popconfirm>}

                            {permission.includes('查看食材') && <Button size="small" type="primary" onClick={() => {
                                baseAxiosNoInfo('/cooking_center/menu_item/food_item_detail', {
                                    params: {
                                        menu_item_id: record.menu_item_id
                                    }
                                }).then((res: any) => {
                                    if (res) {
                                        const args = {
                                            message: '具体食材',
                                            description: res.map((el: any, index: any) => <li key={index}>食材：{el.food_item_name}，用量：{el.use_count}({el.use_unit})，备注：{el.remark}</li>),
                                            duration: 3,
                                        }

                                        notification.open(args)
                                    }
                                })
                            }}>
                                查看食材
                            </Button>}
                        </Space>
                    )}
                />
            </Table>
        </div>

        {/* 膳食中心 -> 菜品管理 -> 菜品管理 -> 新增或编辑 */}
        <Modal title={activeID ? "编辑菜品" : "新增菜品"} visible={addVisible} onCancel={() => { setAddVisible(false) }} footer={false} width="900px">
            <Form {...formItemLayout} form={form} name="validate_other" onFinish={onFinish} >
                <Form.Item label="菜品名称" name="menu_item_name" rules={[{ required: true, message: '必须填菜品名称' }]} >
                    <Input />
                </Form.Item>

                <Form.Item label="菜系" name="menu_style_id" >
                    <Select virtual={false}  >
                        {menuStyleList.map((el: { menu_style_id: string, menu_style_name: string }) =>
                            <Option key={el.menu_style_id} value={el.menu_style_id}>{el.menu_style_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="菜品分类" name="menu_type_id" rules={[{ required: true, message: '必须选择菜品分类' }]} >
                    <Select virtual={false}  >
                        {menuTypeList.map((el: { menu_type_id: string, menu_type_name: string }) =>
                            <Option key={el.menu_type_id} value={el.menu_type_id}>{el.menu_type_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="菜品图片" valuePropName="fileList" name="menu_item_url" getValueFromEvent={uploadFile}
                    rules={[{ required: true, message: '必须上传菜品图片' }]}
                >
                    <Upload
                        maxCount={1}
                        name="files"
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/public/upload_file'}
                        listType="picture-card"
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item label="菜品功效" name="menu_item_desc"  >
                    <Input />
                </Form.Item>

                <Form.Item label="是否含糖" name="is_sugar" rules={[{ required: true, message: '必须选择是否含糖' }]} >
                    <Select virtual={false}  >
                        <Option value={1}>是</Option>
                        <Option value={0}>否</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="高价菜品" name="is_high_price" rules={[{ required: true, message: '必须选择是否高价菜品' }]} >
                    <Select virtual={false}  >
                        <Option value={1}>是</Option>
                        <Option value={0}>否</Option>
                    </Select>
                </Form.Item>

                <Form.Item required label="使用食材" name="food_item_list"  >
                    {
                        formData.map((el, index: number) =>
                            <Row key={el.food_item_id} gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                                <Col span={4}>
                                    <Select allowClear
                                        virtual={false}
                                        placeholder="食材分类"
                                        value={formData[index].food_type_id}
                                        style={{ width: '100%' }}
                                        onChange={(v: string) => {
                                            let f = _.cloneDeep(formData)
                                            f[index].food_type_id = v
                                            f[index].food_item_id = undefined

                                            setFormData(f)

                                            baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                                params: {
                                                    food_type_id: v
                                                }
                                            }).then((res: any) => {
                                                if (res) {
                                                    let s = _.cloneDeep(selects)
                                                    s[index] = res
                                                    setSelects(s)
                                                }
                                            })
                                        }}
                                    >
                                        {
                                            foodTypeList.map((el: { food_type_id: string, food_type_name: string }) =>
                                                <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>
                                            )}
                                    </Select>
                                </Col>

                                <Col span={4}>
                                    <Select allowClear
                                        virtual={false}
                                        placeholder="食材"
                                        value={formData[index].food_item_id}
                                        onChange={(e: string) => {
                                            handleRowChange(index, 'food_item_id', e)
                                            let u = _.cloneDeep(unit);
                                            u[index] = selects[index][selects[index].findIndex((el: any) => el.food_item_id == e)].use_unit
                                            setUnit(u)
                                        }}
                                    >
                                        {selects[index] && selects[index].map((el: any) =>
                                            <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>
                                        )}
                                    </Select>
                                </Col>

                                <Col span={4}>
                                    <Input placeholder="备注" value={el.remark}
                                        onChange={(e) => {
                                            handleRowChange(index, 'remark', e.target.value)
                                        }}
                                    />
                                </Col>

                                <Col span={4}>
                                    <Input
                                        placeholder="用量"
                                        value={el.use_count}
                                        onChange={(e) => {
                                            if (isNaN(Number(e.target.value)) || e.target.value.indexOf('.') >= 0) {
                                                message.error('用量必须填写整数数字')
                                            } else {
                                                handleRowChange(index, 'use_count', e.target.value)
                                            }
                                        }}
                                    />
                                </Col>

                                <Col span={3}><p style={{ lineHeight: '34px' }}>单位{unit[index]}</p></Col>

                                <Col span={1} style={{ paddingTop: 4 }}>
                                    <DeleteOutlined onClick={() => { deleteRow(index) }} style={{ cursor: 'pointer' }} />
                                </Col>
                            </Row>
                        )
                    }

                    <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加食材</Button>
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        {/* 膳食中心 -> 菜品管理 -> 菜品管理 -> 图片查看 */}
        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />

        {/* 膳食中心 -> 菜品管理 -> 菜品管理 -> 图片浏览 */}
        <Modal visible={visible} title='浏览图片' footer={null} onCancel={() => { setVisible(false) }} >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
    </div>)
}